import {useEditor} from "@grapesjs/react";
import {observer} from "mobx-react";
import {useEffect, useState} from "react";
import {useStore} from "../../../app/store";
import {onKeyEscape} from "../../../app/editor/utils/dom";
import InputField from "../InputField";
import {CMD_SELECT_TARGET} from "../../../app/editor/plugins/global/studioPlugin";
import Button from "../../common/Button";
import {findParent} from "../../../app/editor";
import {PropertyUpdateStack} from "../../../app/store/UndoManager";

const HrefType = {
    Url: 'url',
    Pages: 'pages',
    Elements: 'elements',
    Email: 'email',
    Phone: 'phone',
}

const pagesPrefix = 'page://';
const elPrefix = '#';
const emailPrefix = 'mailto:';
const subjectPrefix = 'subject=';
const phonePrefix = 'tel:';

const getHrefType = (value) => {
    if (value.startsWith(phonePrefix)) {
        return HrefType.Phone;
    } else if (value.startsWith(emailPrefix)) {
        return HrefType.Email;
    } else if (value.startsWith(pagesPrefix)) {
        return HrefType.Pages;
    } else if (value.startsWith(elPrefix)) {
        return HrefType.Elements;
    } else {
        return HrefType.Url;
    }
}

const cmpIdLabel = (cmp) => {
    return `${cmp.getName()} - #${cmp.getId()}`;
}

export default observer(function TraitHrefField({trait}) {
    const value = trait.getValue();
    const {appEditorStore, undoManager} = useStore();
    const {isSelectingTarget} = appEditorStore;
    const [, triggerUp] = useState(0);
    const [tab, setTab] = useState(() => getHrefType(value));
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [phone, setPhone] = useState('');
    const [showIdList, setShowIdList] = useState(true);
    const [idList, setIdList] = useState([]);
    const editor = useEditor();
    const pages = editor.Pages.getAll();
    const up = () => triggerUp((i) => ++i);

    const setValue = (newValue) => {
        const prevValue = trait.getValue();
        trait.setValue(newValue);
        const higherComponent = findParent(trait.component);
        const connectedBoardId = higherComponent.attributes.attributes['data-id'];
        const targetComponent = trait.component.attributes.tagName === 'a' ? trait.component : trait.component.parent();
        let {
            selectorType,
            selector,
            selectorIdx,
            parentSelector,
            parentIdx
        } = appEditorStore.getComponentSelector(targetComponent);
        undoManager.add(new PropertyUpdateStack({
            href: prevValue,
            selectorType, selector, selectorIdx, parentSelector, parentIdx,
            connectedBoardId
        }, {
            href: newValue,
            selectorType,
            selector,
            selectorIdx,
            parentSelector,
            parentIdx,
            connectedBoardId
        }))
    };

    const handleTabChange = (newTab) => {
        setTab(newTab);
        setEmail('');
        setSubject('');
        setPhone('');
        setValue('');
    }

    const handlePageChange = (newValue) => {
        setValue(newValue);
        up();
    };

    const handleIdElChange = (option) => {
        if (option) {
            setValue(option.id);
            up();
        }
    };

    const handlePhoneChange = (newValue) => {
        setValue(`${phonePrefix}${newValue}`);
        setPhone(newValue);
    }

    const handleEmailChange = (newValue) => {
        setValue(`${emailPrefix}${newValue}${subject ? `?${subjectPrefix}${subject}` : ''}`);
        setEmail(newValue);
    }

    const handleSubjectChange = (newValue) => {
        setValue(`${emailPrefix}${email}${newValue ? `?${subjectPrefix}${newValue}` : ''}`);
        setSubject(newValue);
    }

    const toogleSelectTarget = () => {
        appEditorStore.setSelectingTarget(!isSelectingTarget);
    };

    const getSelectedOption = (value) => {
        const id = value.replace(elPrefix, '');
        const cmp = editor.Components.componentsById[id];

        return {
            id: value,
            label: cmp ? cmpIdLabel(cmp) : value,
        }
    }

    useEffect(() => {
        let idOptions = [];

        if (showIdList) {
            const invalidTags = ['path', 'br', 'b', 'u', 'i', 'strike'];
            const root = editor.Pages.getSelected()?.getMainComponent();
            root?.forEachChild(cmp => {
                if (
                    !cmp.is('comment')
                    && !cmp.is('textnode')
                    && !invalidTags.includes(cmp.get('tagName'))
                ) {
                    idOptions.push({id: `#${cmp.getId()}`, label: cmpIdLabel(cmp)});
                }
            })
        }

        setIdList(idOptions);

    }, [showIdList]);

    useEffect(() => {
        let offKeyEscape = () => {
        };
        const stop = () => {
            offKeyEscape();
            try {
                if (editor) {
                    editor.stopCommand(CMD_SELECT_TARGET);
                }
            } catch (e) {
                console.log(e);
            }

        };

        if (isSelectingTarget) {
            offKeyEscape = onKeyEscape(stop);
            editor.runCommand(CMD_SELECT_TARGET, {
                onSelect: (cmp) => setValue(`#${cmp.getId()}`),
            });
        }

        return stop;
    }, [isSelectingTarget]);

    useEffect(() => {
        if (!value) return;
        const newType = getHrefType(value);

        switch (newType) {
            case HrefType.Phone:
                setPhone(value.replace(phonePrefix, ''));
                break;
            case HrefType.Email:
                const [email, subjectParam = ''] = value.replace(emailPrefix, '').split('?');
                setEmail(email);
                setSubject(subjectParam.replace(subjectPrefix, ''));
                break;
        }

        setTab(newType);
    }, [value]);

    return (
        <>
            {/*<LabelField size="s">Href</LabelField>*/}
            <InputField
                className="href-input-field"
                placeholder="eg. https://google.com"
                value={appEditorStore.selectedLink}
                label="Href"
                // onChange={setValue}
                onChangeLive={appEditorStore.setSelectedLink}
                size="s"
                type="url"
            />
            <Button
                type={"fill"}
                size={"s"}
                text={"저장"}
                onClickFunc={() => {
                    setValue(appEditorStore.selectedLink);
                }}
            />
        </>
    )
});